"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const WifiHomeM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== "auto") {
        size.width = width;
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
    }
    if (height && height !== "auto") {
        size.height = height;
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "0 0 21 22" }, size, { style: Object.assign({}, insetPosition), fill: fill, "aria-label": "", "aria-hidden": "true", role: "presentation" }),
            react_1.default.createElement("path", { d: "M19.94 10.468a.34.34 0 00-.094-.407L11.09 1.445a.633.633 0 00-.85 0l-8.756 8.616a.344.344 0 00-.094.407.541.541 0 00.519.3h1.1a.67.67 0 01.68.656v8.164a.5.5 0 00.549.434h12.74a.5.5 0 00.546-.434v-8.167a.668.668 0 01.68-.656h1.223a.529.529 0 00.513-.297zm.877-1.323a1.623 1.623 0 01.376 1.833 1.9 1.9 0 01-1.769 1.1h-.546v7.512a1.831 1.831 0 01-1.9 1.745H4.234a1.834 1.834 0 01-1.906-1.745v-7.514h-.422a1.9 1.9 0 01-1.769-1.1 1.625 1.625 0 01.376-1.831L9.272.528a2.105 2.105 0 012.789 0zm-10.188 7.809c.449-.006.449-.249.449-.395s0-.388-.385-.4h-.073c-.337 0-.364.194-.364.395 0 .155 0 .395.373.4zm.039-1.927a1.5 1.5 0 011.584 1.533 1.469 1.469 0 01-1.53 1.53h-.109a1.533 1.533 0 010-3.065.348.348 0 00.058 0zM10.6 7.281a8.623 8.623 0 016.331 2.507.641.641 0 01-.055.926.7.7 0 01-.959-.052 7.351 7.351 0 00-5.275-2.073A7.636 7.636 0 005.4 10.523a.7.7 0 01-.959.046.638.638 0 01-.049-.926A8.96 8.96 0 0110.6 7.281zm.006 2.552a6.933 6.933 0 014.959 1.939.641.641 0 01-.055.926.7.7 0 01-.959-.052 5.638 5.638 0 00-3.912-1.5 5.786 5.786 0 00-3.871 1.534.7.7 0 01-.959.042.637.637 0 01-.049-.923 7.035 7.035 0 014.85-1.967zm.018 2.607a4.673 4.673 0 013.326 1.305.641.641 0 01-.055.926.7.7 0 01-.959-.052 3.383 3.383 0 00-4.556.021.7.7 0 01-.959.042.636.636 0 01-.049-.92 4.732 4.732 0 013.251-1.323z" }))));
};
exports.default = WifiHomeM;
//# sourceMappingURL=index.js.map